import { getLicensePoolProductLabel, getLicensePoolSublicensesLabelWithPrefix } from "./licensePools";

export const getKeyLicensePoolId = key => key && key.license_pool ? key.license_pool._id : '';

export const getKeyLicensePoolLabel = key => !key || !key.license_pool
  ? ''
  : `${getLicensePoolProductLabel(key.license_pool)} ${getLicensePoolSublicensesLabelWithPrefix(key.license_pool)}`.trim();



// WEBPACK FOOTER //
// ./webAdmin/utils/keys.js